import { render } from "./DedMorozSay.vue?vue&type=template&id=e69af9a4"
import script from "./DedMorozSay.vue?vue&type=script&lang=js"
export * from "./DedMorozSay.vue?vue&type=script&lang=js"

import exportComponent from "C:\\work\\game\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__